<app-route-history [vehicle]="vehicle" *ngIf="vehicle" popupSize="resize"></app-route-history>

